import _ from 'underscore';
import { intervalToDuration, formatISODuration } from 'date-fns';

import { logError } from '../logger';
import { getVideoObjectMicrodata } from './videoObjects';
import { getBaseMicrodata, getTextBlocksFromJsonField } from './helpers';

const getParticipantNamesByType = (participants, types) =>
	_(participants).reduce((memo, participant) => {
		let currentType = participant.type.name;
		let currentTypeData = {};

		if (_(types).contains(currentType)) {
			currentType = currentType === 'composer' ? 'musicBy' : currentType;

			currentTypeData = {
				[`${currentType}`]: [
					{
						'@type': 'Person',
						name: participant.person.title
					}
				].concat(memo[currentType] || [])
			};
		}

		return { ...memo, ...currentTypeData };
	}, {});

export const getMovieMicrodata = (movie, entityType = 'movies') => {
	let jsonData = {};

	try {
		jsonData = getVideoObjectMicrodata(movie, entityType);

		if (movie.type === 'movie') {
			const participants = getParticipantNamesByType(movie.participants, [
				'actor',
				'director',
				'producer',
				'composer'
			]);

			let movieJsonData = getBaseMicrodata(movie, {
				type: 'Movie',
				entityType
			});

			movieJsonData = {
				...movieJsonData,
				genre: _.pluck(movie.genres, 'title'),
				inLanguage: movie.language,
				description: getTextBlocksFromJsonField(movie.jsonText),
				duration: formatISODuration(
					intervalToDuration({ start: 0, end: 1000 * movie.duration })
				),
				productionCompany: movie.productionCompanies,
				datePublished: movie.year,
				...participants
			};

			jsonData.push(movieJsonData);
		}

		if (!jsonData.length) {
			jsonData = null;
		}
	} catch (err) {
		logError(`movie microdata error: ${err.stack || err}`);
	}

	return jsonData && JSON.stringify(jsonData);
};
